module.exports = __webpack_public_path__ + "fonts/Manrope-ExtraBold.2adc0bb9.woff";